import React from 'react';
import { Mic, Star } from 'react-feather';
import {
  InlineShell,
  InlineEyebrow,
  CardButton,
  type F8CardData,
  type OnAction,
} from './cardHelpers';

const QUOTA_FALLBACK = "you've used all your voice chat sessions";

function safeIneligibleReason(reason: unknown): string {
  if (typeof reason !== 'string' || reason.trim() === '') return QUOTA_FALLBACK;
  const looksLikeCode = !reason.includes(' ') && reason.length < 60;
  return looksLikeCode ? QUOTA_FALLBACK : reason;
}

function formatTime(input: number | undefined): string {
  if (!input) return '0 min';
  const minutes = input > 120 ? Math.floor(input / 60) : input;
  if (minutes >= 60) return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
  return `${minutes} min`;
}

export default function VoiceLauncherCard({
  card,
  onAction,
}: {
  card: F8CardData;
  onAction?: OnAction;
}) {
  const data = card?.data || {};
  const isPremium = data.tier === 'premium';

  return (
    <InlineShell>
      <InlineEyebrow label="voice" trailing={isPremium ? 'premium' : 'free'} />

      <div className="f8c-voice-head">
        <div className="f8c-voice-orb">
          <Mic size={22} />
        </div>
        <div className="f8c-voice-identity">
          {data.eligible ? (
            <>
              <div className="f8c-voice-title">Ready to chat with f8</div>
              <div className="f8c-voice-meta">
                {isPremium
                  ? `${formatTime(data.remainingTime)} remaining this month.`
                  : `${data.remainingSessions ?? 0} ${
                      data.remainingSessions === 1 ? 'session' : 'sessions'
                    } left.`}
              </div>
            </>
          ) : (
            <div className="f8c-voice-blocked">{safeIneligibleReason(data.reason)}</div>
          )}
        </div>
      </div>

      <div className="f8c-voice-actions">
        {data.eligible ? (
          <CardButton
            primary
            onClick={() =>
              onAction?.({
                action: 'navigate',
                params: { screen: 'ChatScreen', startVoice: true },
              })
            }
          >
            <Mic size={13} />
            Start voice chat
          </CardButton>
        ) : (
          <CardButton
            primary
            onClick={() =>
              onAction?.({ action: 'navigate', params: { screen: 'Premium' } })
            }
          >
            <Star size={13} />
            Upgrade
          </CardButton>
        )}
      </div>
    </InlineShell>
  );
}
